// @ts-nocheck
import React, { useEffect } from 'react';
import { Platform, Text, View, StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { SComponentContainer, SMapView, SNavigation, SText, STheme } from 'servisofts-component';
import SSocket from 'servisofts-socket';
import Redux, { store } from './Redux';
import Config from "./Config";
import Assets from './Assets';
import Pages from './Pages';
import Firebase from './Firebase';
import { NavBar, TopBar } from './Components';
import StatusBar from './Components/StatusBar';
import BackgroundImage from './Components/BackgroundImage';
import packageInfo from "../package.json"
import BackgroundLocation from './BackgroundLocation';
import Socket from './Socket';

import DataBaseContainer from './DataBase/DataBaseContainer';
import ErrorBoundary from './Components/ErrorBoundary';
// import { Example } from 'servisofts-charts';

try {
    Firebase.init();
} catch (e) {
    console.log(e);
}
// SMapView.bootstrapURLKeys.key = "AIzaSyAr7BQ9lDDYgKUq2pIbvMRXS1HqFLI3gDw"

// SMapView.bootstrapURLKeys.key = "AIzaSyDeYTmxobPXPlck4s8x1h785dikyqOU5uI"
SMapView.bootstrapURLKeys.key = "AIzaSyC3YyO8nw0Bm-4TmzvvG3BjQl7xteAfe0E"
// BackgroundLocation();

function AppContent(): JSX.Element {
    // const insets = useSafeAreaInsets();

    return (
        <View style={{
            flex: 1,
            // paddingTop: insets.top,
            // paddingBottom: insets.bottom,
        }}>
            <SComponentContainer
                debug
                socket={SSocket}
                background={<BackgroundImage />}
                assets={Assets}
                inputs={Config.inputs}
                theme={{ themes: Config.theme, initialTheme: "default" }}
                style={{ flex: 1 }}
            >
                <DataBaseContainer>
                    <SNavigation
                        linking={{
                            prefixes: ["https://renova.servisofts.com/app/", "http://renova.servisofts.com/app/", 'renova://app/'],
                            getInitialURL: () => {
                                Firebase.getInitialURL();
                            }
                        }}
                        props={{ navBar: TopBar, title: 'RENOVA', pages: Pages }}
                    />
                    <NavBar />
                    <SText style={{ position: "absolute", bottom: 2, right: 2, zIndex: 0, }} disabled fontSize={10} color={STheme.color.lightGray}>v{packageInfo.version}</SText>
                </DataBaseContainer>
                <Socket store={store} />
            </SComponentContainer>
        </View>
    );
}

function App(): JSX.Element {
    return <Redux>
        <ErrorBoundary>
            <AppContent />
        </ErrorBoundary>
    </Redux>
}


// function AppTest(): JSX.Element {
//     return <Example />
// }

// export default AppTest;
export default App;